export const syncTimeDataToDrawer = (drawerData, index, { timeValue, subTimeValue, selectedOption, inputValue, readOnly }) => {
    if (drawerData?.[index]) {
      drawerData[index].state = {
        ...drawerData[index].state,
        timeValue,
        subTimeValue,
        selectedOption,
        mainInputValue: inputValue,
        readOnly,
      };
    }
  };
  